import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

import { GoogleOAuthProvider } from '@react-oauth/google'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <>
    <GoogleOAuthProvider clientId='539734603559-g6v48cugl0ps2qpbugs50s4srhoa0rdu.apps.googleusercontent.com'>
      <App />
    </GoogleOAuthProvider>
  </>,
)

serviceWorkerRegistration.register()
